import useTranslationHook from "hooks/useTranslationHook";
import { useMemo } from "react";

const useTranslatedList = (list: any, keysToTranslate: string[]) => {
  const { t } = useTranslationHook();

  const translatedList = useMemo(
    () =>
      list.map((item: any) => {
        const translatedItem = { ...item };
        keysToTranslate.forEach((key) => {
          if (key in translatedItem) {
            translatedItem[key] = t(translatedItem[key]);
          }
        });
        return translatedItem;
      }),
    [list, keysToTranslate, t],
  );

  return translatedList;
};

export default useTranslatedList;
